function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 14.925L3.438 18 4.5 11.488 0 6.875l6.219-.95L9 0l2.781 5.925 6.219.95-4.5 4.613L14.562 18z",
  fill: "#E86E63",
  fillRule: "evenodd"
});

var SvgHigh = function SvgHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _ref);
};

export default SvgHigh;